export default __webpack_public_path__ + "static/media/Walker's Legguards of the Golden Horde.77be3895.jpg";